import React from 'react';
import { Table, Button, Spinner, Alert } from 'react-bootstrap';

const VehicleList = ({ vehicles, loading, onEdit, onDelete }) => {
    if (loading) {
        return <Spinner animation="border" />;
    }

    if (vehicles.length === 0) {
        return <Alert variant="info">No vehicles found for this transporter.</Alert>;
    }

    return (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                    <th>Vehicle Number</th>
                    <th>Capacity (tons)</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {vehicles.map(v => (
                    <tr key={v._id}>
                        <td>{v.vehicleNumber}</td>
                        <td>{v.capacity}</td>
                        <td>
                            <span className={`badge bg-${v.isActive ? 'success' : 'danger'}`}>
                                {v.isActive ? 'Active' : 'Inactive'}
                            </span>
                        </td>
                        <td>
                            <Button variant="info" size="sm" onClick={() => onEdit(v)} className="me-2">
                                Edit
                            </Button>
                            {v.isActive && (
                                <Button variant="danger" size="sm" onClick={() => onDelete(v)}>
                                    Deactivate
                                </Button>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default VehicleList;
